import React, { useRef, useEffect } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import getEmbedUrl from 'utils/getEmbedUrl';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import { AspectRatio } from 'react-aspect-ratio';
import {
  videoTranscriptFileUrl,
  videoTranscriptFileExtension,
} from 'utils/videoTranscriptFileUrl';
import { isValidUrl } from 'utils/validateUrlSrc';

const Iframe = styled.iframe`
  @media ${breakpoints.md} {
    max-height: 24.375rem;
  }
  @media ${breakpoints.lg} {
    max-height: 33.125rem;
  }
  @media ${breakpoints.xl} {
    max-height: 40.6rem;
  }
`;

const TimelineMediaSlide = ({
  index,
  position,
  image = {},
  video = {},
  transcript = {},
  transcriptText = '',
}) => {
  const breakpoint = useBreakpoint(
    typeof window !== 'undefined' && window.innerWidth,
  );
  const isMobile = ['sm', 'xs'].includes(breakpoint);
  const ratio = isMobile ? '330/300' : '640/500';
  const showVideo = video && video.href && video.href.length > 10;
  const videoRef = useRef(null);

  useEffect(() => {
    if (index !== position && videoRef && videoRef.current) {
      setTimeout(() => {
        videoRef.current.pause();
      });
    }
  }, [index, position, videoRef]);

  return (
    <div className={cx('w-full ', {})}>
      <AspectRatio ratio={ratio} className='w-full overflow-hidden'>
        <div className='w-full justify-center text-center bg-mattamy-gray-bg rounded'>
          {!showVideo && (
            <img
              src={image && image.src}
              alt={image && image.alt}
              className='h-full min-w-full object-cover rounded bg-mattamy-gray-bg'
            />
          )}

          {showVideo && video.type === 'external' && (
            <div className='videoIframe w-full h-full rounded bg-mattamy-gray-bg'>
              <Iframe
                className='h-full w-full rounded'
                src={getEmbedUrl(video.href, false, true)}
                title={transcriptText}
                aria-label={transcriptText}
              />
            </div>
          )}
          {showVideo && video.type === 'internal' && (
            <video
              src={video.href}
              ref={videoRef}
              className='h-full w-full bg-black rounded '
              controls
              disablePictureInPicture='true'
              controlsList='nodownload'
            />
          )}
        </div>
      </AspectRatio>

      {showVideo &&
        transcriptText &&
        transcript &&
        transcript.link &&
        transcript.link.href && (
          <div className='text-left pb-10 md:pb-4 leading-relaxed text-sm md:text-normal font-graphie'>
            <span className='text-left text-mattamy-blue pb-10 md:pb-4 leading-relaxed text-sm md:text-normal '>
              {'Transcript:'}
            </span>
            <span className='text-left ml-2 text-mattamy-blue  pb-10 md:pb-4 leading-relaxed text-sm md:text-normal underline'>
              <a
                href={videoTranscriptFileUrl(transcript)}
                download={
                  transcript.name +
                  videoTranscriptFileExtension(transcript.extension)
                }
                aria-label={'Download ' + transcriptText + ' transcript'}
              >
                {transcriptText}
              </a>
            </span>
          </div>
        )}
    </div>
  );
};

export default TimelineMediaSlide;
